import Button from '@ui/button/Button';
import analytics from '@utils/analytics';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductBoutiqueModal from '@moncler/components/reserve/ProductBoutiqueModal';
import customEventBus from '@common/scripts/libs/eventBus';
const ProductActionFindInBoutique = (props) => {
    const { t } = useTranslation();
    const [showOverlay, setShowOverlay] = useState(false);
    useEffect(() => {
        if (!props.onlyButton) {
            customEventBus.on('product:openFib', () => {
                setShowOverlay(true);
            });
            return () => {
                customEventBus.off('product:openFib', () => {
                    setShowOverlay(true);
                });
            };
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "button", cls: [props.inverted ? 'button--primary-inverted' : props.secondary ? 'button--secondary' : 'button--primary'], onClick: () => {
                if (props.onlyButton) {
                    customEventBus.emit('product:openFib', {});
                }
                else {
                    setShowOverlay(true);
                }
                analytics.findInBoutique(props.product.masterId);
            } }, t('label.findinboutique')),
        props.product && !props.onlyButton && (React.createElement(ProductBoutiqueModal, { isOpen: showOverlay, title: t('label.findinboutique'), mode: "find", product: props.product, size: props.size, color: props.color, colourVariations: props.colourVariations, sizeVariations: props.sizeVariations, onRequestClose: () => setShowOverlay(false) }))));
};
export default ProductActionFindInBoutique;
